"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumToIndex = void 0;
const sumToIndex = (arr, index = arr.length - 1) => {
    let sum = 0;
    const lastIndex = arr.length - 1;
    const startIndex = index > lastIndex ? lastIndex : index;
    if (arr.length === 0) {
        return sum;
    }
    for (let i = 0; i <= startIndex; i++) {
        sum += arr[i];
    }
    return sum;
};
exports.sumToIndex = sumToIndex;
//# sourceMappingURL=sumToIndex.js.map